function findClimate() {
  const postcodeInput = document.getElementById("postcode");

  if (!postcodeInput) return;

  let postcode = postcodeInput.value.trim();
  const output = document.getElementById("output");

  // --- EXCEPTIONS ---
  const exceptions = {
    "2620": "cool_temperate",
    "2570": "cool_temperate",
    "2480": "subtropical",
    "4225": "subtropical",
    "4350": "subtropical",
    "4800": "tropical",
    "4870": "tropical",
    "5037": "temperate"
  };

  // --- DETERMINE CLIMATE ---
  function getClimate(postcode) {
    if (exceptions[postcode]) {
      return exceptions[postcode];
    }

    const num = parseInt(postcode);

    if (isNaN(num)) return null;

    // NSW
    if (num >= 1000 && num <= 2599) return "temperate";
    if (num >= 2600 && num <= 2899) return "cool_temperate";
    if (num >= 2900 && num <= 2999) return "temperate";

    // VIC
    if (num >= 3000 && num <= 3999) return "temperate";
    if (num >= 8000 && num <= 8999) return "cool_temperate";

    // QLD
    if (num >= 4000 && num <= 4199) return "subtropical";
    if (num >= 4200 && num <= 4499) return "subtropical";
    if (num >= 4500 && num <= 4899) return "tropical";

    // SA
    if (num >= 5000 && num <= 5799) return "temperate";

    return null;
  }

  const climate = getClimate(postcode);

  if (!climate) {
    if (output) {
      output.innerText = "Sorry, we couldn't find a match for that postcode.";
    }
    return;
  }

  if (output) {
    output.innerText = "Redirecting to plants for: " + climate + "...";
  }

  // --- REDIRECT TO COLLECTION ---
  setTimeout(function () {
    window.location.href = "/collections/" + climate;
  }, 800);
}